export const logIfUnsafeFetchTags = (tags?: string[]) => {
	// Vercel has a stated limit of 64 tags: https://vercel.com/docs/data-cache#revalidation-behavior
	if (tags?.length > 64) {
		const message = `This fetch has more than 64 tags. Tags: ${tags}`;
		process.env.NODE_ENV === 'development'
			? console.error(message)
			: console.warn(message);
	}
};
